import { Button, Typography } from "@mui/material";
import React from "react";
import ChangelogDialog from "../components/Changelog/ChangelogDialog";

interface ChangelogProps {
  onOpen?: () => void;
}

const Changelog: React.FC<ChangelogProps> = ({ onOpen }) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    onOpen?.();
    setOpen(true);
  };

  return (
    <>
      <Button sx={{ padding: 0 }} variant="text" onClick={handleOpen}>
        <Typography
          variant="bodySmallWeightRegular"
          sx={(theme) => ({ color: theme.palette.common.black })}
        >
          Release notes
        </Typography>
      </Button>
      <ChangelogDialog open={open} handleClose={handleClose} />
    </>
  );
};

export default Changelog;
